import React from 'react'
import { useSWRConfig } from 'swr'
import DiscountVisibilitySelector from './DiscountVisibilitySelector'
import { startOfDay } from 'date-fns'
import { DiscountFieldPaths } from 'src/lib/types/discountsV2'
import { SectionWrapper } from 'src/components/common/context/SectionWrapper'
import { useDiscountForm } from '../../hooks/useDiscountForm'
import { AvailabilityDates } from '../../common/AvailabilityDates'
import { GenericChannelSelector } from '../../common/GenericChannelSelector'

const AvailabilityValidityV2 = () => {
  const {
    state: { prerequisite, errors },
    actions: { setFormState }
  } = useDiscountForm()

  const { availability } = prerequisite
  const { startDate, endDate, enabledChannelIds = [] } = availability

  const handleStartDateChange = (date: Date | undefined) => {
    if (date) {
      setFormState(
        {
          prerequisite: {
            ...prerequisite,
            availability: { ...availability, startDate: date.getTime() }
          }
        },
        [DiscountFieldPaths.START_DATE]
      )
    }
  }

  const handleEndDateChange = (date: Date | undefined) => {
    setFormState(
      {
        prerequisite: {
          ...prerequisite,
          availability: { ...availability, endDate: date ? date.getTime() : null }
        }
      },
      [DiscountFieldPaths.END_DATE]
    )
  }

  const handleChannelChange = (ids: string[]) => {
    setFormState({
      prerequisite: {
        ...prerequisite,
        availability: { ...availability, enabledChannelIds: ids }
      }
    })
  }

  return (
    <>
      <SectionWrapper sectionKey='channel-selector'>
        <GenericChannelSelector selectedChannelIds={enabledChannelIds} onChange={handleChannelChange} />
      </SectionWrapper>

      <SectionWrapper sectionKey='visibility-selector'>
        <DiscountVisibilitySelector />
      </SectionWrapper>

      <SectionWrapper sectionKey='availability-dates'>
        <AvailabilityDates
          startDate={startDate ? new Date(startDate) : null}
          endDate={endDate ? new Date(endDate) : null}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          errors={{
            startDate: errors[DiscountFieldPaths.START_DATE],
            endDate: errors[DiscountFieldPaths.END_DATE]
          }}
        />
      </SectionWrapper>
    </>
  )
}

export default AvailabilityValidityV2
